import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateAllocationTemplateMutationVariables = Types.Exact<{
  input: Types.CreateAllocationTemplateInput;
}>;


export type CreateAllocationTemplateMutation = { __typename?: 'Mutation', createAllocationTemplate: { __typename?: 'AllocationTemplatePayload', template?: { __typename?: 'AllocationTemplateData', id: string, name: string, equalizeWeeksOfSupply: boolean, favorHigherWeight: boolean, mode: Types.AllocationMode, targetWeeksOfSupply?: number | null, allocationType: Types.AllocationType, priorities: Array<Types.AllocationPriorityDimension> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteAllocationTemplateMutationVariables = Types.Exact<{
  input: Types.DeleteAllocationTemplateInput;
}>;


export type DeleteAllocationTemplateMutation = { __typename?: 'Mutation', deleteAllocationTemplate: { __typename?: 'AllocationTemplatePayload', template?: { __typename?: 'AllocationTemplateData', id: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateAllocationTemplateDocument = new TypedDocumentString(`
    mutation CreateAllocationTemplate($input: CreateAllocationTemplateInput!) {
  createAllocationTemplate(input: $input) {
    template {
      ...AllocationTemplate
    }
    errors {
      code
      message
    }
  }
}
    fragment AllocationTemplate on AllocationTemplateData {
  id
  name
  equalizeWeeksOfSupply
  favorHigherWeight
  mode
  targetWeeksOfSupply
  allocationType
  priorities
}`);
export const DeleteAllocationTemplateDocument = new TypedDocumentString(`
    mutation DeleteAllocationTemplate($input: DeleteAllocationTemplateInput!) {
  deleteAllocationTemplate(input: $input) {
    template {
      id
    }
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateAllocationTemplate: build.mutation<CreateAllocationTemplateMutation, CreateAllocationTemplateMutationVariables>({
      query: (variables) => ({ document: CreateAllocationTemplateDocument, variables })
    }),
    DeleteAllocationTemplate: build.mutation<DeleteAllocationTemplateMutation, DeleteAllocationTemplateMutationVariables>({
      query: (variables) => ({ document: DeleteAllocationTemplateDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateAllocationTemplateMutation, useDeleteAllocationTemplateMutation } = injectedRtkApi;
